
// New exclusive API
export const API_URL = 'https://happy-t-api.herokuapp.com/thoughts'
export const API_URL_HEARTS = (thoughtId) => `https://happy-t-api.herokuapp.com/thoughts/${thoughtId}/hearts`


// Old Technigo public API
//export const API_URL = 'https://happy-thoughts-technigo.herokuapp.com/thoughts'
//export const API_URL_HEARTS = (thoughtId) => `https://happy-thoughts-technigo.herokuapp.com/thoughts/${thoughtId}/like`